import { Order } from "@today/api/taker"
import { Load, PIL_Load } from "@today/api/tracker"
import { isSenderCustomer } from "."

export function getCustomer<T extends Order | Load | PIL_Load>(
  order: T
): T["sender"] {
  return isSenderCustomer(order) ? order.sender : order.receiver
}
